// Pure mapping helpers for the inventory_replenishment report rows used
// on the Review Purchase List screen. Kept in a standalone file with NO
// runtime dependencies so it can be unit-tested without chain-loading
// SupplierModel → report.ts → the ESM-only `dateformat` package.

export interface ReviewInventorySignals {
  stock: number | null;
  incoming: number | null;
  daysLeft: number | null;
  leadTime: number | null;
}

export type InventoryByVariantId = Record<number, ReviewInventorySignals>;

export function toNumberOrNull(raw: unknown): number | null {
  if (raw === null || raw === undefined || raw === '' || raw === 'unknown') { return null; }
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}

export function rowsToInventoryMap(rows: any[]): InventoryByVariantId {
  const out: InventoryByVariantId = {};
  for (const row of rows || []) {
    const id = Number(row?.variant_id ?? row?.['[variant_id]']);
    if (!Number.isFinite(id) || id <= 0) { continue; }
    out[id] = {
      stock:    toNumberOrNull(row['[Actual Inventory Quantity]']),
      incoming: toNumberOrNull(row['[incoming_inventory_quantity]']),
      // The raw report row uses `[stock_days_inventory_planning]`. BuyingTable.vue
      // renames this to `inventoryRemainingDays` after fetch (BuyingTable.vue:2649)
      // — accept either name plus the `daysLeft` alias to match the candidate
      // list in reportRowToPurchaseListItem.ts:24.
      daysLeft: toNumberOrNull(
        row['[stock_days_inventory_planning]']
          ?? row.inventoryRemainingDays
          ?? row.daysLeft,
      ),
      // `[vendor_lead_time]` is the report code (BuyingTable.vue:4263); BuyingTable
      // renames it to `vendorLeadTime` after fetch (BuyingTable.vue:2745) — accept
      // either. Supplier/vendor-level; absent for the unassigned bucket → null.
      leadTime: toNumberOrNull(
        row['[vendor_lead_time]'] ?? row.vendorLeadTime,
      ),
    };
  }
  return out;
}
